<template>
  <div class="organisations-page pa-6">
    <p-container>
      <!-- Title -->
      <h2 class="mb-4">
        {{ $t('navigation.page.organisations.title') }}
      </h2>
      <p-row>
        <!-- Search Field -->
        <p-col xs12 md6 lg3>
          <p-text-field v-model="page.organisationsDataSource.filter.searchCriteria" clearable :label="$t('core.app.search')" context-icon="search"></p-text-field>
        </p-col>
        <!-- Event Filter -->
        <p-col xs12 md6 lg3>
          <p-select
            v-model="page.eventsDataSource.filter.eventIdentifier"
            :label="$t('page.events.select.eventName')"
            :items="page.eventItems"
            @input="page.refreshOrganisations()"
          ></p-select>
        </p-col>
      </p-row>
      <p-list-view ref="organisationList" v-model="page.organisationsList" :pagination.sync="page.organisationsDataSource.paging" :columns="page.organisationColumns" :loading="page.organisationsDataSource.isLoading">
        <template slot="table-actions">
          <!-- Refresh Button -->
          <p-button @click="page.refreshOrganisations()">
            <p-icon>refresh</p-icon>
          </p-button>
        </template>
        <!-- Edit Organisation Button -->
        <template #copyButton="{ row }">
          <p-button :title="$t('page.organisations.button.copyAccessToken')" @click="page.copyAccessToken(row)">
            <p-icon>content_copy</p-icon>
          </p-button>
        </template>
        <template #editButton="{ row }">
          <p-button @click="page.gotoDetail(row.values.id)">
            <p-icon>edit</p-icon>
          </p-button>
        </template>
      </p-list-view>
    </p-container>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import OrganisationsPage from './organisations.vue.model';

  export default Vue.extend({
    role: ['Admin', 'Hostadmin'],
    auth: true,
    data: () => ({
      page: new OrganisationsPage(),
    }),
    async beforeMount() {
      await this.page.initialize();
    },

  });
</script>
